import { render, staticRenderFns } from "./submitPanel.vue?vue&type=template&id=5f138c23&"
import script from "./submitPanel.vue?vue&type=script&lang=js&"
export * from "./submitPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports